/* unplugin-vue-components disabled */import script from "./AppNavLocalePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavLocalePicker.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__